<template>
  <div>
    <purchase-select
      v-if="canAssignToParent"
      ref="select-purchase"
      :purchaseCategory="purchaseCategory"
      :customerID="customerID"
      :warehouse="warehouse" />
    <d-alert
      v-if="!canAssignToParent"
      show
      theme="warning">
      {{ $t('purchase.relation.cannotBeAssignedToParent') }}
    </d-alert>

    <fieldset
      v-if="parent">
      <legend>{{ $t('purchase.relation.parentPurchase') }}</legend>

      <p>
        {{ parent.orders_names }} (#{{ parent.id }})

        <router-link :to="'/zakupy/edycja/' + parent.id">
          {{ $t('purchase.relation.openThisPurchase') }}
        </router-link>
      </p>
    </fieldset>

    <fieldset
      v-if="children.length">
      <legend>{{ $t('purchase.relation.childrenPurchases') }}</legend>

      <ol>
        <li
          v-for="(child, index) of children"
          :key="'child-purchase-' + index">
          {{ child.orders_name }} (#{{ child.id }})

          <router-link :to="'/zakupy/edycja/' + child.id">
            {{ $t('purchase.relation.openThisPurchase') }}
          </router-link>
        </li>
      </ol>
    </fieldset>
  </div>
</template>

<script>
import PurchaseSelect from './PurchaseSelect.vue';
import Vue from 'vue';

export default {
  name: 'purchase-relations',
  props: [
    'canAssignToParent',
    'canAssignToThis',
    'parentID',
    'parent',
    'children',
    'purchaseCategory',
    'customerID',
    'warehouse'
  ],
  components: {
    'purchase-select': PurchaseSelect
  },
  data () {
    return {
      parent_id: 0
    };
  },
  mounted () {
    if (this.parentID !== 0) {
      this.parent_id = this.parentID;

      Vue.nextTick(() => {
        this.$refs['select-purchase'].loadPurchase(this.parentID);
      });
    }

    this.$bus.$on('purchase-select-change', this.updateParentID);
  },
  methods: {
    updateParentID (purchaseID) {
      if (purchaseID === null) {
        this.parent_id = 0;
      } else {
        this.parent_id = parseInt(purchaseID, 10);
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('purchase-select-change', this.updateParentID);
  }
}
</script>
